import { useEffect } from "react";

// Keeps a socket.io room membership alive across reconnects.
//
// Rooms live on the server side of the connection. After any reconnect — a
// server restart, a pod rotating, a network blip — the socket comes back but
// is no longer in the room, so room broadcasts (new chat messages) stop
// arriving until the page is reloaded. The bell kept working through this
// because the header re-registers the user on every connect; the chat pages
// only joined their room once, on load. Re-join on every "connect" while the
// page is open. Joining a room twice is harmless.
export const useRoomRejoin = (socket, joinEvent, roomId) => {
  useEffect(() => {
    if (!socket || !roomId) return undefined;
    const join = () => socket.emit(joinEvent, { roomId });
    socket.on("connect", join);
    return () => {
      socket.off("connect", join);
    };
  }, [socket, joinEvent, roomId]);
};
